module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_de-811adce6094cceddec0412e2d0c93bc0.png";